// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"58148683","160":"c810a8bf","208":"4d563db0","293":"c9e8edf6","453":"f2859243","516":"afcfb61d","519":"e15209a7","917":"e9ad2efe","946":"918bd3be"}[chunkId] + ".chunk.js";
};